/* ========================== */
/*         HOME HERO          */
/* ========================== */
homeHeroSlider = {
  init: function () {
    if ($(".swiper--home-hero").length > 0) {
      var swiper = new Swiper(".swiper--home-hero", {
        slidesPerView: 1,
        effect: "fade",
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        mousewheel: {
          invert: false,
          forceToAxis: true
        },
        pagination: {
          el: ".swiper-pagination",
        },
      });

      /*   ---   PROGRESS BAR ANIMATION   ---   */
      // Setup on init and on pagination update
      swiper.on('paginationUpdate', function () {
        extendBullets();
        animateProgressBar(swiper);
      });

      swiper.on('slideChangeTransitionStart', function () {
        animateProgressBar(swiper);
      });

      swiper.on('autoplay', function () {
        animateProgressBar(swiper);
      });

      // If user clicks a bullet, reset progress bars and animate the new active one
      $(document).on('click', '.swiper-pagination-bullet', function () {
        setTimeout(function () {
          animateProgressBar(swiper);
        }, 30); // allow Swiper to update the active bullet
      });

      // Initial setup
      extendBullets();
      animateProgressBar(swiper);

      // Helper to reset all progress bars
      function resetProgressBars() {
        var $bullets = $('.swiper-pagination-bullet');
        $bullets.each(function () {
          var $this = $(this);
          var $progress = $this.find('.bullet-progress');
          $progress.stop(true, true);
          $progress.css({
            width: '0%',
          });
        });
      }

      // Function to animate the active bullet's progress bar
      function animateProgressBar(swiperInstance) {
        // Fallback duration
        var duration = swiperInstance?.params?.autoplay?.delay || 5000;

        var $bullets = $('.swiper-pagination-bullet');
        var activeIndex = swiperInstance.realIndex; // 0-based slide index if loop is true

        resetProgressBars();

        // Animate the active bullet
        var $activeBullet = $bullets.eq(activeIndex);
        var $progress = $activeBullet.find('.bullet-progress');
        $progress.animate(
          { width: '100%' },
          duration,
          "linear"
        );
      }

      // Extend bullets: add inner progress bar div
      function extendBullets() {
        $('.swiper-pagination-bullet').each(function () {
          if ($(this).find('.bullet-progress').length === 0) {
            $(this).css('position', 'relative');
            var $progress = $('<div class="bullet-progress"></div>');
            $progress.css({ width: '0%' });
            $(this).append($progress);
          }
        });
      }
    }
  }
};

$(document).ready(function () {
  homeHeroSlider.init();
});


